import { z } from 'zod';
const LANGUAGE_STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
} as const;
export const baseLanguage = z.object({
  name: z.string(),
  isoCode: z.string(),
});

export const tenantLanguage = baseLanguage.extend({
  status: z.literal(LANGUAGE_STATUS.ACTIVE),
  humanName: z.string(),
  resolvedIsoCode: z.string(),
});
